import "core-js/modules/es6.regexp.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import EntityPicker from 'src/components/Pickers/Picker';
import Project from 'src/store/models/Project';
import { dialog } from 'src/boot/mixins.js';
import { forEach } from 'lodash';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog,
    EntityPicker: EntityPicker
  },
  props: ['onComplete'],
  data: function data() {
    return {
      loading: false,
      projects: [this.getProjectRowTemplate(), this.getProjectRowTemplate(), this.getProjectRowTemplate()]
    };
  },
  methods: {
    addNewProject: function addNewProject() {
      this.projects.push(this.getProjectRowTemplate());
    },
    createProjects: function createProjects() {
      var _this = this;

      this.loading = true;
      Project.api().post('/projects/create-from-template', {
        account_id: this.me.account_id,
        projects: this.projects
      }).then(function (response) {
        if (process.env.GOOGLE_ANALYTICS_ENABLED) {
          window.ueuq = window.uetq || [];
          window.ueuq.push('event', 'project_create', {}); // HUBSPOT

          window._hsq.push(['setPath', 'project/create']);

          window._hsq.push(['trackPageView']);

          if (_this.$gtag) {
            _this.$gtag.event('project_create', process.env.GOOGLE_ANALYTICS_DEBUGMODE ? {
              debug_mode: true
            } : {});
          }
        }

        _this.loading = false;

        _this.hide();
      }).catch(function (errors) {
        // we have to reset the errors before parsing the new ones
        forEach(_this.projects, function (project, index, array) {
          array[index].errors = _this.getProjectErrorsTemplate();
        });
        forEach(errors.response.data.errors, function (error, index) {
          var pieces = index.split('.');

          if (pieces[0] === 'projects' && pieces[1] >= 0) {
            if (pieces[2]) {
              if (pieces[3]) {
                if (_this.projects[pieces[1]]) {
                  _this.projects[pieces[1]].errors[pieces[2]][pieces[3]].active = true;
                  _this.projects[pieces[1]].errors[pieces[2]][pieces[3]].message = error[0];
                }
              } else {
                if (_this.projects[pieces[1]]) {
                  _this.projects[pieces[1]].errors[pieces[2]].active = true;
                  _this.projects[pieces[1]].errors[pieces[2]].message = error[0];
                }
              }
            }
          }
        });
        forEach(_this.$refs, function (refsKey) {
          if (refsKey[0] && typeof refsKey[0].validate === 'function') {
            refsKey[0].validate();
          }
        });
        _this.loading = false;
      });
    },
    removeProject: function removeProject(project, index) {
      this.projects.splice(index, 1);
    },
    getProjectRowTemplate: function getProjectRowTemplate() {
      return {
        name: null,
        template: {
          project_id: -1
        },
        group_id: -1,
        client_id: -1,
        errors: this.getProjectErrorsTemplate()
      };
    },
    getProjectErrorsTemplate: function getProjectErrorsTemplate() {
      return {
        name: {
          active: false,
          message: ''
        },
        template: {
          project_id: {
            active: false,
            message: ''
          }
        },
        group_id: {
          active: false,
          message: ''
        },
        client_id: {
          active: false,
          message: ''
        }
      };
    }
  }
};